import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';

import { AuthProvider }         from './context/AuthContext';
import { NotificationProvider } from './context/NotificationContext';
import { ProtectedRoute }       from './components/common/ProtectedRoute';

import { LoginPage, RegisterPage } from './pages/AuthPages';
import { DashboardPage }           from './pages/DashboardPage';
import { EmailsPage }              from './pages/EmailsPage';
import { EmailDetailPage }         from './pages/EmailDetailPage';
import { ComposePage }             from './pages/ComposePage';
import { AnalyticsPage }           from './pages/AnalyticsPage';
import { SettingsPage }            from './pages/SettingsPage';
import { NotFoundPage }            from './pages/NotFoundPage';

const App = () => (
  <BrowserRouter>
    <AuthProvider>
      <NotificationProvider>
        {/* Toast notifications */}
        <Toaster
          position="bottom-right"
          toastOptions={{
            style: {
              background: 'var(--bg-elevated)',
              color:      'var(--text-primary)',
              border:     '1px solid var(--border-light)',
              fontFamily: 'var(--font-mono)',
              fontSize:   '0.78rem',
              borderRadius: '8px',
            },
            success: { iconTheme: { primary: '#00e1c8', secondary: '#0a0a0f' } },
            error:   { iconTheme: { primary: '#ff4d6d', secondary: '#0a0a0f' } },
            duration: 3500,
          }}
        />

        <Routes>
          {/* Public */}
          <Route path="/login"    element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />

          {/* Protected */}
          <Route path="/dashboard"     element={<ProtectedRoute><DashboardPage /></ProtectedRoute>} />
          <Route path="/emails"        element={<ProtectedRoute><EmailsPage /></ProtectedRoute>} />
          <Route path="/emails/:id"    element={<ProtectedRoute><EmailDetailPage /></ProtectedRoute>} />
          <Route path="/compose"       element={<ProtectedRoute><ComposePage /></ProtectedRoute>} />
          <Route path="/analytics"     element={<ProtectedRoute><AnalyticsPage /></ProtectedRoute>} />
          <Route path="/settings"      element={<ProtectedRoute><SettingsPage /></ProtectedRoute>} />

          {/* Redirects */}
          <Route path="/"  element={<Navigate to="/dashboard" replace />} />
          <Route path="*"  element={<NotFoundPage />} />
        </Routes>
      </NotificationProvider>
    </AuthProvider>
  </BrowserRouter>
);

export default App;
